import React from "react";
// Sections for this page
import { CreateTagInput as Tag } from "API";

import { Link } from "gatsby";
import Chip from "@material-ui/core/Chip";

// const useStyles = makeStyles(styles);

type Props = {
  tag: Tag;
};

export default function TagLink(props: Props) {
  // const classes = useStyles();
  const { tag } = props;

  return (
    <Link to={`/tags/${tag.slug}`}>
      <Chip
        size="small"
        color="primary"
        style={{ cursor: "pointer" }}
        label={tag.name}
      />
    </Link>
  );
}
